export class StringUtils {
    static isNullOrEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value.trim() === '';
    }

    static getNumberOrDefault(value: string | null | undefined, defaultValue: number) : number {
        if( value )  {
            var num = Number(value);
            return isNaN(num) ? defaultValue : num;
        }
        return defaultValue;
    }
}